export default "__VITE_ASSET__DNi04gnc__"